<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_WHITEBOARD/mixin';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomWhiteBoardCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>, plan?.plan_code)}
                <AltProratedPlanUser type={plan.type}>
                {this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.license'))}
                </AltProratedPlanUser>
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                {this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
